import React from 'react';
import SlideOutSidebar from 'ui-components/slide-out-sidebar/slideOutSidebar';
import './drivers.scss';
import { useSelector } from 'react-redux';
import { driversSelector } from 'slices/drivers/driversSlice';
import moment from 'moment';
import { Popover } from 'ui-components/popover/popover';

interface FilterSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const DriverDetailsSidebar: React.FC<FilterSidebarProps> = ({ isOpen, onClose }) => {
  const driverState = useSelector(driversSelector);

  return (
    <SlideOutSidebar
      show={isOpen}
      onClose={onClose}
      header={driverState.selectedDriver?.firstName + " " + driverState.selectedDriver?.lastName}
      size="small"
      className="filter-sidebar"
    >
      <div>
        <div className='drivers-sidebar__header'>Driver Information</div>
        <div className='drivers-sidebar__content'>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Driver ID (Auto-generated)</div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.driverId}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Name</div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.firstName + " " + driverState.selectedDriver?.lastName}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>CDL # <Popover values={<div className='driver-details-tooltip'>CDL stands for Commercial Driver’s License number — a unique number issued to each driver</div>}/></div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.commercialDriverLicense?.licenseNumber ?? 'N/A'}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>CDL Class <Popover values={<div className='driver-details-tooltip'>Indicates the type of vehicle the driver is licensed to operate. Class A: large trucks, Class B: buses, Class C: smaller vehicles.</div>}/></div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.commercialDriverLicense?.licenseClass ?? 'N/A'}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Address</div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.address ?
              driverState.selectedDriver?.address.street + ", " + driverState.selectedDriver?.address.city
              + ", " + driverState.selectedDriver?.address.state + ", " +
              driverState.selectedDriver?.address.zipcode : 'N/A'}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Phone</div>
            <div className='drivers-sidebar__content__item__value'>{
              driverState.selectedDriver?.phone ?
                driverState.selectedDriver?.phone?.formatPhone() : 'N/A'}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Terminal <Popover values={<div className='driver-details-tooltip'>The driver’s assigned work location or dispatch point.</div>}/></div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.domicileTerminalNumber ?? 'N/A'}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>Status</div>
            <div className='drivers-sidebar__content__item__value'>{driverState.selectedDriver?.status === "active" ?
              <div className="drivers-list__status drivers-list__status__active">{driverState.selectedDriver?.status}</div> :
              <div className="drivers-list__status drivers-list__status__inactive">{driverState.selectedDriver?.status}</div>}</div>
          </div>
          <div className='drivers-sidebar__content__item'>
            <div className='drivers-sidebar__content__item__label'>License Expiration</div>
            <div className='drivers-sidebar__content__item__value'>{
              driverState.selectedDriver?.commercialDriverLicense?.expirationDate ?
                moment(driverState.selectedDriver?.commercialDriverLicense?.expirationDate).format("MM-DD-YYYY") : "N/A"}</div>
          </div>
        </div>
      </div>
    </SlideOutSidebar>
  );
};

export default DriverDetailsSidebar;
